// extracted by mini-css-extract-plugin
export default {"nameInput":"OrgGroupForm_nameInput__OG9L2","placeHolderShimmer":"OrgGroupForm_placeHolderShimmer__5eTeh"};